import React from "react"

import type { Notices } from "@/lib/notices"

import { NoticeItem } from "@/components/Notice/Item"

export type NoticeListComponentProps = {
  className?: React.HTMLAttributes<HTMLDivElement>[`className`]
  listEmptyClassName?: React.HTMLAttributes<HTMLDivElement>[`className`]
  notices: Notices.ContextData
}

type State = Record<string, never>

export class NoticeListComponent extends React.PureComponent<
  NoticeListComponentProps,
  State
> {
  public render = () => {
    if (this.props.notices.list.length < 1) {
      return <div className={this.props.listEmptyClassName}></div>
    }

    return (
      <div className={this.props.className}>
        {this.props.notices.list.map((item) => {
          return <NoticeItem key={item.id} item={item} />
        })}
      </div>
    )
  }
}
